import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  parseCalculatorParams,
  parseContractorParams,
  type ParsedCalculatorParams,
  type ParsedContractorParams,
} from '@/utils/queryParams';

/**
 * Hook to parse calculator query parameters on mount.
 * Returns parsed parameters that can be used to prefill form fields.
 *
 * One-way sync: URL → Form on page load only (form changes don't update URL).
 */
export function useCalculatorQueryParams(): ParsedCalculatorParams {
  const [searchParams] = useSearchParams();

  return useMemo(() => parseCalculatorParams(searchParams), [searchParams]);
}

/**
 * Hook to parse contractor query parameters on mount.
 * Returns parsed parameters that can be used to prefill form fields.
 *
 * One-way sync: URL → Form on page load only (form changes don't update URL).
 */
export function useContractorQueryParams(): ParsedContractorParams {
  const [searchParams] = useSearchParams();

  return useMemo(() => parseContractorParams(searchParams), [searchParams]);
}
